document.addEventListener('DOMContentLoaded', () => {
    const koupaniButtonShowSymbolExplanationBox: HTMLAnchorElement = document.querySelector('#vysvetlivkyButton') as HTMLAnchorElement;
    const koupaniButtonHideSymbolExplanationBox: HTMLAnchorElement = document.querySelector('#vysvetlivkyCloseButton') as HTMLAnchorElement;
    const koupaniBoxSymbolExplanation: HTMLDivElement              = document.querySelector('#koupani_vys') as HTMLDivElement;

    document.addEventListener('click', (event: MouseEvent) => {

        // Mouse event
        if (! (event.target instanceof HTMLElement)) {
            return;
        }

        // Click on 'vysvětlivky použitých symbolů' button(anchor tag).
        if (event.target === koupaniButtonShowSymbolExplanationBox) {
            event.preventDefault();

            // Toggle visibility.
            if (koupaniBoxSymbolExplanation.style.display === 'none') {
                koupaniBoxSymbolExplanation.style.display = 'block';
            } else {
                koupaniBoxSymbolExplanation.style.display = 'none';
            }

        }
        // Click on close button(anchor tag) 'Zavřít' inside the explanation box.
        else if (event.target === koupaniButtonHideSymbolExplanationBox
            || koupaniButtonHideSymbolExplanationBox.contains(event.target)
        ) {
            event.preventDefault();
            koupaniBoxSymbolExplanation.style.display = 'none';
        }
        // Click somewhere outside the explanation box.
        else if (! koupaniBoxSymbolExplanation.contains(event.target)) {
            koupaniBoxSymbolExplanation.style.display = 'none';
        }

    });
})